(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-guide-content"]) return;
  try {
    

$(document).ready(function () {
    $(".GiftGuideScroll").click(function () {
      $(this).parents('li').siblings().removeClass('active');
	  $(this).parents('li').addClass('active');
    })
  });

  } catch(e) { console.error(e); }
})();
})();
